<template>
  <div v-if="loaded">
    <div class="table_sec industry_financials_sec">
      <div class="md-layout-item md-size-100 page">
        <div class="section_body">
          <div class="section_title">
            <h2>Financial Ratios</h2>
          </div>
          <h3 class="sub_header mb-2">Cash flow-Solvency</h3>
          <div class="table-box">
            <div class="tbl-title">
              <h4>Cash flow-Solvency</h4>
            </div>
            <!-- <h6 class="mt-2 mb-2">{{ tablesInfo[item.name]["title"] }}</h6> -->
            <div class="inner-tbl">
              <md-table
                v-model="cashflowFirm"
                table-header-color="blue"
                class="dark_blue"
                style="flex: 1;"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell class="md-table-side-label" md-label="Firm">
                    {{ item.title }}
                    <md-tooltip md-direction="bottom">{{
                      item.rollover
                    }}</md-tooltip>
                  </md-table-cell>
                  <md-table-cell
                    v-for="key in Object.keys(item.dates)"
                    :key="key"
                    :md-label="key"
                    >{{ item.dates[key] }}</md-table-cell
                  >
                </md-table-row>
              </md-table>
            </div>
            <div class="inner-tbl">
              <md-table
                v-model="cashflowIndustry"
                table-header-color="blue"
                class="dark_blue"
                style="flex: 1;"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell
                    class="md-table-side-label"
                    md-label="Industry"
                  >
                    {{ item.title }}
                    <md-tooltip md-direction="bottom">{{
                      item.rollover
                    }}</md-tooltip>
                  </md-table-cell>
                  <md-table-cell
                    v-for="key in Object.keys(item.dates)"
                    :key="key"
                    :md-label="key"
                    >{{ item.dates[key] }}</md-table-cell
                  >
                </md-table-row>
              </md-table>
            </div>
            <div class="inner-tbl">
              <md-table
                v-model="cashflowVariance"
                table-header-color="blue"
                class="dark_blue"
                style="flex: 1;"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell
                    class="md-table-side-label"
                    md-label="Variance"
                  >
                    {{ item.title }}
                    <md-tooltip md-direction="bottom">{{
                      item.rollover
                    }}</md-tooltip>
                  </md-table-cell>
                  <md-table-cell
                    v-for="key in Object.keys(item.dates)"
                    :key="key"
                    :md-label="key"
                    >{{ item.dates[key] }}</md-table-cell
                  >
                </md-table-row>
              </md-table>
            </div>
          </div>
          <p class="common_footer footer-formatting">
            Copyright © 2022 Bizminer. All Rights Reserved.
          </p>
        </div>
      </div>
      <div class="md-layout-item md-size-100 page">
        <div class="section_body">
          <div class="md-layout">
            <div
              v-for="(chart, index) in chartsCashflow"
              :key="index"
              class="md-layout-item box-ratio md-medium-size-100 md-size-50"
            >
              <h4 class="sub_header ratio-chart-title mb-2">
                {{ chart.title }}
              </h4>
              <LineChartMulti
                v-if="chart"
                height="200px"
                :categories="chart.data.labels"
                :chartdata="chart.data.series"
              />
            </div>
          </div>
          <p class="common_footer footer-formatting">
            Copyright © 2022 Bizminer. All Rights Reserved.
          </p>
        </div>
      </div>
      <div class="md-layout-item md-size-100 page">
        <div class="section_body">
          <h3 class="sub_header mb-2">Profitability</h3>
          <div class="table-box">
            <div class="tbl-title">
              <h4>Profitability</h4>
            </div>
            <div class="inner-tbl">
              <md-table
                v-model="profitabilityFirm"
                table-header-color="blue"
                class="dark_blue"
                style="flex: 1;"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell class="md-table-side-label" md-label="Firm">
                    {{ item.title }}
                    <md-tooltip md-direction="bottom">{{
                      item.rollover
                    }}</md-tooltip>
                  </md-table-cell>
                  <md-table-cell
                    v-for="key in Object.keys(item.dates)"
                    :key="key"
                    :md-label="key"
                    >{{ item.dates[key] }}</md-table-cell
                  >
                </md-table-row>
              </md-table>
            </div>
            <div class="inner-tbl">
              <md-table
                v-model="profitabilityIndustry"
                table-header-color="blue"
                class="dark_blue"
                style="flex: 1;"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell
                    class="md-table-side-label"
                    md-label="Industry"
                  >
                    {{ item.title }}
                    <md-tooltip md-direction="bottom">{{
                      item.rollover
                    }}</md-tooltip>
                  </md-table-cell>
                  <md-table-cell
                    v-for="key in Object.keys(item.dates)"
                    :key="key"
                    :md-label="key"
                    >{{ item.dates[key] }}</md-table-cell
                  >
                </md-table-row>
              </md-table>
            </div>
            <div class="inner-tbl">
              <md-table
                v-model="profitabilityVariance"
                table-header-color="blue"
                class="dark_blue"
                style="flex: 1;"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell
                    class="md-table-side-label"
                    md-label="Variance"
                  >
                    {{ item.title }}
                    <md-tooltip md-direction="bottom">{{
                      item.rollover
                    }}</md-tooltip>
                  </md-table-cell>
                  <md-table-cell
                    v-for="key in Object.keys(item.dates)"
                    :key="key"
                    :md-label="key"
                    >{{ item.dates[key] }}</md-table-cell
                  >
                </md-table-row>
              </md-table>
            </div>
          </div>
          <p class="common_footer footer-formatting">
            Copyright © 2022 Bizminer. All Rights Reserved.
          </p>
        </div>
      </div>
      <div class="md-layout-item md-size-100 page">
        <div class="section_body">
          <div class="md-layout">
            <div
              v-for="(chart, index) in chartsProfitability"
              :key="index"
              class="md-layout-item box-ratio md-medium-size-100 md-size-50"
            >
              <h4 class="sub_header ratio-chart-title mb-2">
                {{ chart.title }}
              </h4>
              <LineChartMulti
                v-if="chart"
                height="200px"
                :categories="chart.data.labels"
                :chartdata="chart.data.series"
              />
            </div>
          </div>
          <p class="common_footer footer-formatting">
            Copyright © 2022 Bizminer. All Rights Reserved.
          </p>
        </div>
      </div>

      <div class="md-layout-item md-size-100 page">
        <div class="section_body">
          <h3 class="sub_header mb-2">Efficiency</h3>
          <div class="table-box">
            <div class="tbl-title">
              <h4>Efficiency</h4>
            </div>
            <div class="inner-tbl">
              <md-table
                v-model="efficiencyFirm"
                table-header-color="blue"
                class="dark_blue"
                style="flex: 1;"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell class="md-table-side-label" md-label="Firm">
                    {{ item.title }}
                    <md-tooltip md-direction="bottom">{{
                      item.rollover
                    }}</md-tooltip>
                  </md-table-cell>
                  <md-table-cell
                    v-for="key in Object.keys(item.dates)"
                    :key="key"
                    :md-label="key"
                    >{{ item.dates[key] }}</md-table-cell
                  >
                </md-table-row>
              </md-table>
            </div>
            <div class="inner-tbl">
              <md-table
                v-model="efficiencyIndustry"
                table-header-color="blue"
                class="dark_blue"
                style="flex: 1;"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell
                    class="md-table-side-label"
                    md-label="Industry"
                  >
                    {{ item.title }}
                    <md-tooltip md-direction="bottom">{{
                      item.rollover
                    }}</md-tooltip>
                  </md-table-cell>
                  <md-table-cell
                    v-for="key in Object.keys(item.dates)"
                    :key="key"
                    :md-label="key"
                    >{{ item.dates[key] }}</md-table-cell
                  >
                </md-table-row>
              </md-table>
            </div>
          </div>
          <p class="common_footer footer-formatting">
            Copyright © 2022 Bizminer. All Rights Reserved.
          </p>
        </div>
      </div>

      <div class="md-layout-item md-size-100 page">
        <div class="section_body">
          <div class="table-box">
            <div class="tbl-title">
              <h4>Efficiency</h4>
            </div>
            <div class="inner-tbl">
              <md-table
                v-model="efficiencyVariance"
                table-header-color="blue"
                class="dark_blue"
                style="flex: 1;"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell
                    class="md-table-side-label"
                    md-label="Variance"
                  >
                    {{ item.title }}
                    <md-tooltip md-direction="bottom">{{
                      item.rollover
                    }}</md-tooltip>
                  </md-table-cell>
                  <md-table-cell
                    v-for="key in Object.keys(item.dates)"
                    :key="key"
                    :md-label="key"
                    >{{ item.dates[key] }}</md-table-cell
                  >
                </md-table-row>
              </md-table>
            </div>
          </div>
          <div class="md-layout">
            <div
              v-for="(chart, index) in chartsEfficiencyFirst"
              :key="index"
              class="md-layout-item box-ratio md-medium-size-100 md-size-50"
            >
              <h4 class="sub_header ratio-chart-title mb-2">
                {{ chart.title }}
              </h4>
              <LineChartMulti
                v-if="chart"
                height="200px"
                :categories="chart.data.labels"
                :chartdata="chart.data.series"
              />
            </div>
          </div>
          <p class="common_footer footer-formatting">
            Copyright © 2022 Bizminer. All Rights Reserved.
          </p>
        </div>
      </div>

      <div class="md-layout-item md-size-100 page">
        <div class="section_body">
          <div class="md-layout">
            <div
              v-for="(chart, index) in chartsEfficiency"
              :key="index"
              class="md-layout-item box-ratio md-medium-size-100 md-size-50"
            >
              <h4 class="sub_header ratio-chart-title mb-2">
                {{ chart.title }}
              </h4>
              <LineChartMulti
                v-if="chart"
                height="200px"
                :categories="chart.data.labels"
                :chartdata="chart.data.series"
              />
            </div>
          </div>
          <p class="common_footer footer-formatting">
            Copyright © 2022 Bizminer. All Rights Reserved.
          </p>
        </div>
      </div>

      <div class="md-layout-item md-size-100 page">
        <div class="section_body">
          <h3 class="sub_header mb-2">Debt-Risk</h3>
          <div class="table-box">
            <div class="tbl-title">
              <h4>Debt-Risk</h4>
            </div>
            <div class="inner-tbl">
              <md-table
                v-model="debtRiskFirm"
                table-header-color="blue"
                class="dark_blue"
                style="flex: 1;"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell class="md-table-side-label" md-label="Firm">
                    {{ item.title }}
                    <md-tooltip md-direction="bottom">{{
                      item.rollover
                    }}</md-tooltip>
                  </md-table-cell>
                  <md-table-cell
                    v-for="key in Object.keys(item.dates)"
                    :key="key"
                    :md-label="key"
                    >{{ item.dates[key] }}</md-table-cell
                  >
                </md-table-row>
              </md-table>
            </div>
            <div class="inner-tbl">
              <md-table
                v-model="debtRiskIndustry"
                table-header-color="blue"
                class="dark_blue"
                style="flex: 1;"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell
                    class="md-table-side-label"
                    md-label="Industry"
                  >
                    {{ item.title }}
                    <md-tooltip md-direction="bottom">{{
                      item.rollover
                    }}</md-tooltip>
                  </md-table-cell>
                  <md-table-cell
                    v-for="key in Object.keys(item.dates)"
                    :key="key"
                    :md-label="key"
                    >{{ item.dates[key] }}</md-table-cell
                  >
                </md-table-row>
              </md-table>
            </div>
            <div class="inner-tbl">
              <md-table
                v-model="debtRiskVariance"
                table-header-color="blue"
                class="dark_blue"
                style="flex: 1;"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell
                    class="md-table-side-label"
                    md-label="Variance"
                  >
                    {{ item.title }}
                    <md-tooltip md-direction="bottom">{{
                      item.rollover
                    }}</md-tooltip>
                  </md-table-cell>
                  <md-table-cell
                    v-for="key in Object.keys(item.dates)"
                    :key="key"
                    :md-label="key"
                    >{{ item.dates[key] }}</md-table-cell
                  >
                </md-table-row>
              </md-table>
            </div>
          </div>
          <p class="common_footer footer-formatting">
            Copyright © 2022 Bizminer. All Rights Reserved.
          </p>
        </div>
      </div>
      <div class="md-layout-item md-size-100 page">
        <div class="section_body">
          <div class="md-layout">
            <div
              v-for="(chart, index) in chartsDebtrisk"
              :key="index"
              class="md-layout-item box-ratio md-medium-size-100 md-size-50"
            >
              <md-card class="md-card-profile m-0">
                <md-card-content class="border-0">
                  <h4 class="sub_header ratio-chart-title mb-2">
                    {{ chart.title }}
                  </h4>
                  <LineChartMulti
                    v-if="chart"
                    height="200px"
                    :categories="chart.data.labels"
                    :chartdata="chart.data.series"
                  />
                </md-card-content>
              </md-card>
            </div>
          </div>
          <p class="common_footer footer-formatting">
            Copyright © 2022 Bizminer. All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { ChartCard } from "@/components";
import { mapState } from "vuex";
import formatData from "@/mixins/format-data";
import ratingMixin from "@/mixins/rating-mixin";
import LineChartMulti from "@/components/LineChartMulti.vue";

export default {
  components: {
    // ChartCard,
    LineChartMulti,
  },
  mixins: [formatData, ratingMixin],
  data() {
    return {
      loaded: false,
      view: "cash-flow-solvency",

      newChartCashflowOptions: [],
      newChartProfitabilityOptions: [],
      newChartDebtOptions: [],
      newChartEfficiencyOptions: [],
      chartOptions: {
        lineSmooth: this.$Chartist.Interpolation.cardinal({
          tension: 1,
        }),
        chartPadding: {
          top: 5,
          right: 5,
          bottom: 5,
          left: 5,
        },
        axisY: {
          showGrid: false,
          showLabel: false,
          offset: 0,
          forceNiceScale: false,
        },
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0,
          scaleMinSpace: 6,
        },
        showPoint: true,
        showLabel: false,
        width: "100px",
        height: "25px",
        seriesBarDistance: 10,
        fullWidth: true,
      },
      filtered_years: [],
      filtered_firms: [],
      filtered_PLDollar: [],
      filtered_PLPercent: [],
      filtered_BSDollar: [],
      filtered_BSPercent: [],
      cashflow: [],
      cashflowVariance: [],
      cashflowFirm: [],
      cashflowIndustry: [],
      profitabilityVariance: [],
      profitabilityFirm: [],
      profitabilityIndustry: [],
      efficiencyVariance: [],
      efficiencyFirm: [],
      efficiencyIndustry: [],
      debtRiskVariance: [],
      debtRiskFirm: [],
      debtRiskIndustry: [],
      cashFlowFilteredData: [],
      efficiency: [],
      efficiencyFilteredData: [],
      profitability: [],
      profitabilityFilteredData: [],
      turnover: [],
      debtRiskFilteredData: [],
      changein: [],
      changeinFilteredData: [],
      worksheet: [],
      worksheetFilteredData: [],
      chartData: {},
      showDialog: false,
      sales_class_csv: "",
      chartsCashflow: [],
      chartsProfitability: [],
      chartsEfficiency: [],
      chartsEfficiencyFirst: [],
      chartsDebtrisk: [],
    };
  },
  computed: {
    ...mapState({
      data: (state) => state.user.report.data,
      profile: (state) => state.user.report,
      PLtable: (state) =>
        state.user.report.tables ? state.user.report.tables["PL"] : null,
      BStable: (state) =>
        state.user.report.tables ? state.user.report.tables["BS"] : null,
      charts: (state) =>
        state.user.report.chartData
          ? state.user.report.chartData["ratios"]
          : null,
      tables: (state) =>
        state.user.report.tables ? state.user.report.tables["ratios"] : null,
      tablesInfo: (state) =>
        state.user.report.tables ? state.user.report.tables["ratioInfo"] : null,
      sourcesUses: (state) =>
        state.user.report ? state.user.report["sourcesUses"] : null,
      sourceYears: (state) =>
        state.user.report.sourcesUsers
          ? state.user.report["sourcesUses"]["years"]
          : null,
      release_display: (state) => state.user.report.release_display,
      bznaics_code: (state) => state.user.report.bznaics,
      sector_name: (state) =>
        state?.user?.report?.data && state?.user?.report?.data[0]
          ? state.user.report.data[0].sector
          : null,
      industry_title: (state) =>
        state?.user?.report?.data && state?.user?.report?.data[0]
          ? state.user.report.data[0].industry
          : null,
      sales_class: (state) =>
        state?.user?.report?.data && state?.user?.report?.data[0]
          ? state.user.report.data[0].sales_class
          : null,
      display_area: (state) =>
        state?.user?.report?.data && state?.user?.report?.data[0]
          ? state.user.report.data[0].display_area
          : null,
      companyName: (state) => state.user?.companyName,
    }),
    sourceTablesInfo() {
      return _.omit(this.sourcesUses, "years");
    },
    filteredProfile() {
      return Object.values(this.profile.data).filter((item) => item);
    },
    getCsvData() {
      let csvData = [
        ["Industry Financial Report"],
        ['"Release Date"', this.release_display],
        [""],
        ["Segment", "Industry"],
        [this.industry_title],
        ["[" + parseInt(this.bznaics_code) + "]" + " Sector", this.sector_name],
        ["Market", this.display_area],
        ["Sales Class", this.sales_class_csv],
        [""],
      ];
      csvData.push(["Firms Analyzed", this.filtered_years]);
      csvData.push(["", this.filtered_firms]);
      csvData.push([""]);
      csvData.push(["Income and Expense - Profit and Loss($)"]);
      csvData.push(["", this.filtered_years]);
      this.filtered_PLDollar.forEach((e, i) => {
        if (e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push(["Income and Expense - Profit and Loss(%)"]);
      csvData.push(["", this.filtered_years]);
      this.filtered_PLPercent.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push(["Balance Sheet($)"]);
      csvData.push(["Assets", this.filtered_years]);
      this.filtered_BSDollar.forEach((e, i) => {
        if (e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push(["Balance Sheet(%)"]);
      csvData.push(["Assets", this.filtered_years]);
      this.filtered_BSPercent.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push(["Financial Ratios: Cash Flow-Solvency"]);
      csvData.push(["", this.filtered_years]);
      this.cashFlowFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push([""]);
      csvData.push([""]);
      csvData.push(["Financial Ratios: Profitability"]);
      csvData.push(["", this.filtered_years]);
      this.profitabilityFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push([""]);
      csvData.push(["Financial Ratios: Efficiency"]);
      csvData.push(["", this.filtered_years]);
      this.efficiencyFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push([""]);
      csvData.push(["Financial Ratios: Debt-Risk"]);
      csvData.push(["", this.filtered_years]);
      this.debtRiskFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push([""]);
      csvData.push([""]);
      csvData.push(["Sources & Uses of Funds"]);
      csvData.push(["", this.sourceYears]);
      this.changeinFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push(["Worksheet:"]);
      this.worksheetFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      return csvData;
    },
    filteredData() {
      return Object.values(this.data).filter((item) => item);
    },
    actualData() {
      return this.filteredData[0]["cashflow"];
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    "$route.query.section"() {
      let section = this.$route.query.section;

      if (!section) {
        section = "cash-flow-solvency";
      }

      this.switchView(section);
    },
    sourceYears(newVal, oldVal) {
      if (this.sourceTablesInfo && newVal) {
        Object.entries(this.sourceTablesInfo).forEach(([table, data]) =>
          this.$set(this, table, this.formatSourcesData(table, data))
        );
      }
    },
    profile(newVal, oldVal) {
      this.init();
    },
  },
  methods: {
    switchView: function(type) {
      this.view = type;
    },
    formatSourcesData(table, data) {
      let getDates = (id) =>
        this.sourceYears.reduce((acc, cur, index) => {
          let value = this.actualData[this.sourceYears.length - index - 1][id];

          value = isNaN(Number(value)) ? value : Number(value.toFixed(0));

          return { ...acc, [cur]: value };
        }, {});

      return data.map((item) => ({
        ...item,
        dates: getDates(item.id),
      }));
    },
    init() {
      let section = this.$route.query.section;

      if (!section) {
        section = "cash-flow-solvency";
      }

      this.switchView(section);

      if (this.profile.years)
        this.profile.years.forEach((e, i) => {
          this.filtered_years.push(Number(e));
        });

      if (this.profile.data) {
        let firmData = Object.values(this.profile.data)
          .filter((item) => item)
          .map((item) => ({ ...item, firms: item.firms }));

        firmData.forEach((element) => {
          this.filtered_firms.push(parseFloat(element.firms));
        });
      }
      if (this.sales_class && this.sales_class.includes(",")) {
        this.sales_class_csv = this.sales_class.replace(/,/g, "");
      }
      let PLdollar = this.formatTable(this.PLtable, "industry", "dollar");
      let PLpercent = this.formatTable(this.PLtable, "industry", "percent");

      PLdollar.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_PLDollar.push(v);
      });
      PLpercent.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_PLPercent.push(v);
      });

      let BSdollar = this.formatTable(this.BStable, "industry", "dollar");
      let BSpercent = this.formatTable(this.BStable, "industry", "percent");

      BSdollar.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });

        v.unshift(element.name);
        this.filtered_BSDollar.push(v);
      });
      BSpercent.forEach((element) => {
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_BSPercent.push(v);
      });

      if (!_.isEmpty(this.tables)) {
        Object.entries(this.tables).forEach(
          ([table, data]) => (this[table] = this.formatTable(data, "industry"))
        );
      }

      let cashFlowData = [];
      this.cashflow.forEach((element, index) => {
        if (element.name in this.tables["cashflow"]) {
          cashFlowData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]["title"],
          });
        }
      });
      cashFlowData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });

        v.unshift(element.title);
        this.cashFlowFilteredData.push(v);
      });

      this.cashflow.forEach((element) => {
        this.newChartCashflowOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i].toString().replace(/,/g, "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i].toString().replace(/,/g, "")
                ),
              ],
            ],
          },
        };
      });

      // Cash Flow
      if (this.tables) {
        let CFVariance = this.formatTable(this.tables["cashflow"], "variance");
        CFVariance.forEach((element) => {
          if (
            element.name in this.tables["cashflow"] &&
            this.tablesInfo[element.name]
          ) {
            this.cashflowVariance.push({
              dates: element.dates,
              title: this.tablesInfo[element.name]["title"],
              rollover: this.tablesInfo[element.name]["rollover"],
            });
          }
        });

        let CFFirm = this.formatTable(this.tables["cashflow"], "firm");
        CFFirm.forEach((element) => {
          if (
            element.name in this.tables["cashflow"] &&
            this.tablesInfo[element.name]
          ) {
            this.cashflowFirm.push({
              dates: element.dates,
              title: this.tablesInfo[element.name]["title"],
              rollover: this.tablesInfo[element.name]["rollover"],
            });
          }
        });

        let CFIndustry = this.formatTable(this.tables["cashflow"], "industry");
        CFIndustry.forEach((element) => {
          if (
            element.name in this.tables["cashflow"] &&
            this.tablesInfo[element.name]
          ) {
            this.cashflowIndustry.push({
              dates: element.dates,
              title: this.tablesInfo[element.name]["title"],
              rollover: this.tablesInfo[element.name]["rollover"],
            });
          }
        });
      }

      // Cashflow chart
      if (this.profile.chartData) {
        if (this.profile.chartData["ratios"]) {
          let chartData = this.profile.chartData["ratios"]["cashflow"];
          let chartsCashflow = this.formatMultipleChart(chartData);

          chartsCashflow.forEach((ch) => {
            ch.data.series = [
              {
                name: "Industry",
                data: ch.data.series[0],
              },
              {
                name: this.companyName ? this.companyName : "Your Firm",
                data: ch.data.series[1],
              },
            ];
          });
          this.chartsCashflow = chartsCashflow;
        } else {
          let chartData = [];
        }
      } else {
        let chartData = [];
      }

      // Profitability
      if (this.tables) {
        let PVariance = this.formatTable(
          this.tables["profitability"],
          "variance"
        );
        PVariance.forEach((element) => {
          if (
            element.name in this.tables["profitability"] &&
            this.tablesInfo[element.name]
          ) {
            this.profitabilityVariance.push({
              dates: element.dates,
              title: this.tablesInfo[element.name]["title"],
              rollover: this.tablesInfo[element.name]["rollover"],
            });
          }
        });

        let PFirm = this.formatTable(this.tables["profitability"], "firm");
        PFirm.forEach((element) => {
          if (
            element.name in this.tables["profitability"] &&
            this.tablesInfo[element.name]
          ) {
            this.profitabilityFirm.push({
              dates: element.dates,
              title: this.tablesInfo[element.name]["title"],
              rollover: this.tablesInfo[element.name]["rollover"],
            });
          }
        });

        let PIndustry = this.formatTable(
          this.tables["profitability"],
          "industry"
        );
        PIndustry.forEach((element) => {
          if (
            element.name in this.tables["profitability"] &&
            this.tablesInfo[element.name]
          ) {
            this.profitabilityIndustry.push({
              dates: element.dates,
              title: this.tablesInfo[element.name]["title"],
              rollover: this.tablesInfo[element.name]["rollover"],
            });
          }
        });
      }

      // Profitability chart
      if (this.profile.chartData) {
        if (this.profile.chartData["ratios"]) {
          let chartData = this.profile.chartData["ratios"]["profitability"];
          let chartsProfitability = this.formatMultipleChart(chartData);

          chartsProfitability.forEach((ch) => {
            ch.data.series = [
              {
                name: "Industry",
                data: ch.data.series[0],
              },
              {
                name: this.companyName ? this.companyName : "Your Firm",
                data: ch.data.series[1],
              },
            ];
          });
          this.chartsProfitability = chartsProfitability;
        } else {
          let chartData = [];
        }
      } else {
        let chartData = [];
      }

      // Efficiency
      if (this.tables) {
        let EVariance = this.formatTable(this.tables["efficiency"], "variance");
        EVariance.forEach((element) => {
          if (
            element.name in this.tables["efficiency"] &&
            this.tablesInfo[element.name]
          ) {
            this.efficiencyVariance.push({
              dates: element.dates,
              title: this.tablesInfo[element.name]["title"],
              rollover: this.tablesInfo[element.name]["rollover"],
            });
          }
        });

        let EFirm = this.formatTable(this.tables["efficiency"], "firm");
        EFirm.forEach((element) => {
          if (
            element.name in this.tables["efficiency"] &&
            this.tablesInfo[element.name]
          ) {
            this.efficiencyFirm.push({
              dates: element.dates,
              title: this.tablesInfo[element.name]["title"],
              rollover: this.tablesInfo[element.name]["rollover"],
            });
          }
        });

        let EIndustry = this.formatTable(this.tables["efficiency"], "industry");
        EIndustry.forEach((element) => {
          if (
            element.name in this.tables["efficiency"] &&
            this.tablesInfo[element.name]
          ) {
            this.efficiencyIndustry.push({
              dates: element.dates,
              title: this.tablesInfo[element.name]["title"],
              rollover: this.tablesInfo[element.name]["rollover"],
            });
          }
        });
      }

      // Efficiency chart
      if (this.profile.chartData) {
        if (this.profile.chartData["ratios"]) {
          let chartData = this.profile.chartData["ratios"]["efficiency"];
          let chartsEfficiency = this.formatMultipleChart(chartData);
          let chartsEfficiencyFirst = chartsEfficiency.splice(0, 2);

          chartsEfficiency.forEach((ch) => {
            ch.data.series = [
              {
                name: "Industry",
                data: ch.data.series[0],
              },
              {
                name: this.companyName ? this.companyName : "Your Firm",
                data: ch.data.series[1],
              },
            ];
          });
          this.chartsEfficiency = chartsEfficiency;

          chartsEfficiencyFirst.forEach((ch) => {
            ch.data.series = [
              {
                name: "Industry",
                data: ch.data.series[0],
              },
              {
                name: this.companyName ? this.companyName : "Your Firm",
                data: ch.data.series[1],
              },
            ];
          });
          this.chartsEfficiencyFirst = chartsEfficiencyFirst;
        } else {
          let chartData = [];
        }
      } else {
        let chartData = [];
      }

      // Debt Risk
      if (this.tables) {
        let DRVariance = this.formatTable(this.tables["turnover"], "variance");
        DRVariance.forEach((element) => {
          if (
            element.name in this.tables["turnover"] &&
            this.tablesInfo[element.name]
          ) {
            this.debtRiskVariance.push({
              dates: element.dates,
              title: this.tablesInfo[element.name]["title"],
              rollover: this.tablesInfo[element.name]["rollover"],
            });
          }
        });

        let DRFirm = this.formatTable(this.tables["turnover"], "firm");
        DRFirm.forEach((element) => {
          if (
            element.name in this.tables["turnover"] &&
            this.tablesInfo[element.name]
          ) {
            this.debtRiskFirm.push({
              dates: element.dates,
              title: this.tablesInfo[element.name]["title"],
              rollover: this.tablesInfo[element.name]["rollover"],
            });
          }
        });

        let DRIndustry = this.formatTable(this.tables["turnover"], "industry");
        DRIndustry.forEach((element) => {
          if (
            element.name in this.tables["turnover"] &&
            this.tablesInfo[element.name]
          ) {
            this.debtRiskIndustry.push({
              dates: element.dates,
              title: this.tablesInfo[element.name]["title"],
              rollover: this.tablesInfo[element.name]["rollover"],
            });
          }
        });
      }

      // Debt-risk chart
      if (this.profile.chartData) {
        if (this.profile.chartData["ratios"]) {
          let chartData = this.profile.chartData["ratios"]["turnover"];
          let chartsDebtrisk = this.formatMultipleChart(chartData);

          chartsDebtrisk.forEach((ch) => {
            ch.data.series = [
              {
                name: "Industry",
                data: ch.data.series[0],
              },
              {
                name: this.companyName ? this.companyName : "Your Firm",
                data: ch.data.series[1],
              },
            ];
          });
          this.chartsDebtrisk = chartsDebtrisk;
        } else {
          let chartData = [];
        }
      } else {
        let chartData = [];
      }

      let efficiencyData = [];
      this.efficiency.forEach((element, index) => {
        if (element.name in this.tables["efficiency"]) {
          efficiencyData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]["title"],
          });
        }
      });
      efficiencyData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });

        v.unshift(element.title);
        this.efficiencyFilteredData.push(v);
      });
      this.efficiency.forEach((element) => {
        this.newChartEfficiencyOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i].toString().replace(/,/g, "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i].toString().replace(/,/g, "")
                ),
              ],
            ],
          },
        };
      });
      let profitabilityData = [];
      this.profitability.forEach((element, index) => {
        if (element.name in this.tables["profitability"]) {
          profitabilityData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]["title"],
          });
        }
      });
      profitabilityData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });

        v.unshift(element.title);
        this.profitabilityFilteredData.push(v);
      });
      this.profitability.forEach((element) => {
        this.newChartProfitabilityOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i].toString().replace(/,/g, "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i].toString().replace(/,/g, "")
                ),
              ],
            ],
          },
        };
      });
      let debtRiskData = [];
      this.turnover.forEach((element, index) => {
        if (element.name in this.tables["turnover"]) {
          debtRiskData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]["title"],
          });
        }
      });
      debtRiskData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });

        v.unshift(element.title);
        this.debtRiskFilteredData.push(v);
      });
      this.turnover.forEach((element) => {
        this.newChartDebtOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i].toString().replace(/,/g, "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i].toString().replace(/,/g, "")
                ),
              ],
            ],
          },
        };
      });
      if (this.sourceYears & this.sourceTablesInfo)
        Object.entries(this.sourceTablesInfo).forEach(([table, data]) =>
          this.$set(this, table, this.formatSourcesData(table, data))
        );

      this.changein.forEach((element, index) => {
        let k = [];
        Object.values(element.dates).forEach((e, index) => {
          k.push(e);
        });
        k.unshift(element.title);
        this.changeinFilteredData.push(k);
      });
      this.worksheet.forEach((element, index) => {
        let k = [];
        Object.values(element.dates).forEach((e, index) => {
          k.push(e);
        });
        k.unshift(element.title);
        this.worksheetFilteredData.push(k);
      });

      this.loaded = true;
    },
  },
};
</script>
